import { RolesType } from './AuthorizationWrapper';

/**
 * Product
 */
export const canCreateProducts: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];

/**
 * Buyer Central
 */
export const canAddBuyer: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];

/**
 * Purchase Orders
 */
export const canCreatePurchaseOrder: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];

export const canApprovePurchaseOrder: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];

/**
 * Received Quotations
 */
export const canAcceptAReceivedQuotation: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];
/**
 * Received Invoices
 */
export const canAcceptAReceivedInvoice: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];

/**
 * Supplier Central
 */
export const canAddSupplier: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];
/**
 * Quotations
 */
export const canCreateQuotation: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];

export const canApproveQuotation: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];
/**
 * Invoices
 */
export const canCreateInvoice: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];

export const canApproveInvoice: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];

/**
 * Received Purchase Orders
 */
export const canAcceptAReceivedPurchaseOrder: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];

/**
 * Letter of Credit
 *
 * An LC application is a trade document, so it follows the purchase-order shape:
 * anyone in either family may prepare one, and only the approver tier signs it
 * off. Roles decide who may act; they cannot make the maker and the checker
 * different people, which is an identity check on the application itself.
 */
export const canCreateLetterOfCredit: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Operations Requestor',
    'Operations Approver',
    'Operations Peers',
    'Developer',
];

export const canApproveLetterOfCredit: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Operations Approver',
    'Operations Peers',
];

/**
 * Fund My Purchases
 */
export const canCreateFundMyPurchaseRequest: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Developer',
];

export const canApproveFundMyPurchaseRequest: RolesType[] = ['Administrator', 'Financing Approver', 'Financing Peers'];

/**
 * Fund From Sales
 */
export const canCreateFundFromSaleRequest: RolesType[] = [
    'Administrator',
    'Financing Approver',
    'Financing Peers',
    'Financing Requestor',
    'Developer',
];

export const canApproveFundFromSaleRequest: RolesType[] = ['Administrator', 'Financing Approver', 'Financing Peers'];

/**
 * KYC Verify
 */
export const canVerifyKYC: RolesType[] = ['Administrator', 'KYC Verifier', 'KYC Approver'];

/**
 * KYC Approve
 */
export const canApproveKYC: RolesType[] = ['Administrator', 'KYC Verifier'];

/**
 * Guarantee Verify
 */
export const canVerifyGuarantee: RolesType[] = ['Administrator', 'Guarantees Verifier', 'Guarantees Approver'];

/**
 * Guarantee Approve
 */
export const canApproveGuarantee: RolesType[] = ['Administrator', 'Guarantees Approver'];

export const canAddUser: RolesType[] = ['Administrator'];
/**
 * Bank Settings
 */
export const canViewUsers: RolesType[] = ['Administrator'];

export const canViewUserGroups: RolesType[] = ['Administrator'];

/**
 * The two halves of a letter of credit decision.
 *
 * A maker records a recommendation, which commits the bank to nothing; a checker
 * countersigns it, which does. Kept as separate lists rather than one
 * "can decide" list because the whole control is that the two are different
 * people — a single list cannot express that, and an officer holding it would
 * see both halves of their own decision.
 */
export const canRecommendLetterOfCredit: RolesType[] = ['Administrator', 'Trade Finance Verifier'];

export const canCountersignLetterOfCredit: RolesType[] = ['Administrator', 'Trade Finance Approver'];
